import React from "react";
// material
import { Grid, Stack, Box } from "@mui/material";
// ------
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AppReviewCompletedData from "./AppReviewCompletedData";


export default function AppReviewCompleted() {
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };


  return (
    <Accordion
      expanded={expanded === "panel1"}
      onChange={handleChange("panel1")}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <h3 style={{ color: "#1f108e" }}>Review Completed</h3>
      </AccordionSummary>
      <AccordionDetails>
        <AppReviewCompletedData></AppReviewCompletedData>
      </AccordionDetails>
    </Accordion>
  );
}
